import './cssFiles/common.css';
import './cssFiles/modal.css';
import './cssFiles/root-body.css';
import './cssFiles/sidebar.css';
import './cssFiles/warning-page.css';
import './cssFiles/table-grid.css';


export const importCSS = () => {};